
import { DisplayElementModel } from './display-element.model';
import { SocialLinkModel } from './link.model';
import { SocialLinkStyleModel } from './link-style.model';
import { LinkTypesEnum } from '../enums/link-types.enum';

export class LinkDisplayElementModel extends DisplayElementModel {
    declare styles: SocialLinkStyleModel;
    links: SocialLinkModel[];

    constructor(
        styles?: any,
        links?: SocialLinkModel[]
    ) {
        super();
        this.styles = new SocialLinkStyleModel(styles);
        if (links) {
            this.links = links.map(link => new SocialLinkModel(link.type, link.url, link.text));
        } else {
            this.links = [
                new SocialLinkModel(LinkTypesEnum.twitter, '')
            ];
        }
        this.isBoundToGlobalStyles = true;
    }

    canRender(): boolean {
        return this.links.length && this.links.some(link => link.isUrlValid());
    }

    clone(): DisplayElementModel {
        const copy = new LinkDisplayElementModel(JSON.parse(JSON.stringify(this.styles)));
        copy.links = this.links.map(_link => _link.clone());
        copy.displayType = this.displayType;

        return copy;
    }

    onUpdate(): boolean | Promise<boolean> {
        return false;
    }

    isEqual(other: LinkDisplayElementModel): boolean {
        if (!other) {
            return false;
        }
        if (!this.styles.equals(other.styles, true)) {
            return false;
        }
        // Compare Links
        for (let i = 0; i < this.links.length; i++) {
            if (!this.links[i].equals(other.links[i])) {
                return false;
            }
        }
        if (this.isBoundToGlobalStyles !== other.isBoundToGlobalStyles) {
            return false;
        }
        return true;
    }
}
